import { isBrowser } from 'src/utils/platform';
import { IDebugEnv, Tenancy } from '../../types';
const defaultEnv = __DEV__
    ? isBrowser
        ? IDebugEnv.DEV
        // : IDebugEnv.DEV
        : IDebugEnv.PRE_PROD
    : IDebugEnv.PROD;
export const getDefaultDebugSettingsState = () => ({
    env: defaultEnv,
    webEnv: defaultEnv,
    disableHotReload: false,
    tenancy: __TEST__ ? Tenancy.TEST : __DEV__ ? Tenancy.DEV : Tenancy.PROD,
});
